<style scoped>
  .initModal {
    padding: 0 12px;
    text-align: center;
  }
  #registercontent{
    margin:0 auto;
    text-align: center;
    width: 500px;
  }

</style>
<template>
  <div>
      <div id="registercontent" width="400">
        <div>
          <Tabs value="phoneRegister" :animated="false" @on-click="changeTabs">
            <TabPane label="手机注册" name="phoneRegister">
              <Form ref="phoneFormParams" :model="phoneFormParams" :rules="phoneRuleValidate" class="initModal">
                <FormItem prop="mobile">
                  <Input v-model.trim="phoneFormParams.mobile" placeholder="手机号码" style="width:323px;" :maxlength="11" @on-blur="phoneValid"></Input>
                </FormItem>
                <FormItem>
                  <Row>
                    <Col span="15">
                      <FormItem prop="mobileCode">
                        <Input v-model.trim="phoneFormParams.mobileCode" placeholder="手机验证码" style="width:152px; position:relative; left:4px;" @on-blur="phoneCodeValid"></Input>
                      </FormItem>
                    </Col>
                    <Col span="2">
                      <FormItem>
                        <Button type="default" :disabled="disabledMobile || mobileTime > 0" @click="sendMobileCode" style="background-color: #ececec;padding:12px 16px;width:102px;">{{ mobileText }}</Button>
                      </FormItem>
                    </Col>
                  </Row>
                </FormItem>
                <FormItem prop="password">
                  <Input v-model.trim="phoneFormParams.password" type="password" placeholder="密码长度应介于6~16位之间" style="width:323px;"></Input>
                </FormItem>
                <FormItem prop="confirmPassword">
                  <Input v-model.trim="phoneFormParams.confirmPassword" type="password" placeholder="再次确认密码" style="width:323px;"></Input>
                </FormItem>
                <FormItem prop="carrierType">
                    <RadioGroup v-model="phoneFormParams.carrierType">
                      <Radio :label="0">我是第三方物流</Radio>
                      <Radio :label="1">我是海外仓</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem style="position: relative; right:21px;">
                  <Checkbox v-model="singlePhone">已阅读并同意</Checkbox><a href="https://open.tongtool.com/guides.html#/?docId=2" target="_blank">《通途开放平台开发者服务协议》</a>
                </FormItem>
              </Form>
            </TabPane>
            <TabPane label="邮箱注册" name="emailRegister">
              <Form ref="emailFormParams" :model="emailFormParams" :rules="emailRuleValidate" class="initModal">
                <FormItem prop="email">
                  <Input v-model.trim="emailFormParams.email" placeholder="邮箱地址" style="width:323px;" @on-blur="emailValid"></Input>
                </FormItem>
                <FormItem>
                  <Row>
                    <Col span="15">
                      <FormItem prop="emailCode">
                        <Input v-model.trim="emailFormParams.emailCode" placeholder="邮箱验证码" style="width:152px;position:relative; left:4px;" @on-blur="emailCodeValid"></Input>
                      </FormItem>
                    </Col>
                    <Col span="2">
                      <FormItem>
                        <Button type="default" :disabled="disabledEmail || emailTime > 0" @click="sendEmailCode" style="background-color: #ececec;padding:12px 16px;width:102px;">{{ emailText }}</Button>
                      </FormItem>
                    </Col>
                  </Row>
                </FormItem>
                <FormItem prop="password">
                  <Input v-model.trim="emailFormParams.password" type="password" placeholder="密码长度应介于6~16位之间" style="width:323px;"></Input>
                </FormItem>
                <FormItem prop="confirmPassword">
                  <Input v-model.trim="emailFormParams.confirmPassword" type="password" placeholder="再次确认密码" style="width:323px;"></Input>
                </FormItem>
                <FormItem prop="carrierType" style="marign-left:1px;">
                    <RadioGroup v-model="emailFormParams.carrierType">
                      <Radio :label="0">我是第三方物流</Radio>
                      <Radio :label="1">我是海外仓</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem style="position: relative; right:21px;">
                  <Checkbox v-model="singleEmail">已阅读并同意</Checkbox><a href="https://open.tongtool.com/guides.html#/?docId=2" target="_blank">《通途开放平台开发者服务协议》</a>
                </FormItem>
              </Form>
            </TabPane>
          </Tabs>
        </div>
        <div style="padding:0 39px;">
          <Button type="primary" size="large" long @click="registerBtn">立即注册</Button>
          <div class="clear" style="padding:12px 0;">
            <div class="fr">
              <a @click="gotoforgethtml">找回密码</a>&nbsp;&nbsp;&nbsp;&nbsp;
              <span>已有账号？</span><a @click="Login">请直接登录></a>
            </div>
          </div>
        </div>
        <div slot="footer"></div>
      </div>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
export default {
  mixins: [ Mixin, tableMixin ],
  components: {},
  data () {
    let self = this;
    const validateCarrierType = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('必须选择类型'));
      } else {
        callback();
      }
    };
    return {
      isShow: true,
      singlePhone: true,
      singleEmail: true,
      phoneFormParams: {
        mobile: '', // 手机号码
        mobileCode: '', // 手机验证码
        carrierType: '',
        password: '', // 密码
        confirmPassword: '' // 确认密码
      },
      phoneRuleValidate: {
        mobile: [
          { required: true, message: '手机号码不能为空', trigger: 'blur' },
          { validator: self.validateMobile(), trigger: 'blur' } // 手机号码校验
        ],
        mobileCode: [
          { required: true, message: '手机验证码不能为空', trigger: 'blur' }
        ],
        carrierType: [
          { required: true, validator: validateCarrierType, trigger: 'change' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: self.validatePassword(), trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次确认密码', trigger: 'blur' },
          { validator: self.validateMobileConfirmPwd(), trigger: 'blur' }
        ]
      },
      emailFormParams: {
        email: '', // 邮箱
        emailCode: '', // 邮箱验证码
        carrierType: '',
        password: '', // 密码
        confirmPassword: '' // 确认密码
      },
      emailRuleValidate: {
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        emailCode: [
          { required: true, message: '邮箱验证码不能为空', trigger: 'blur' }
        ],
        carrierType: [
          { required: true, validator: validateCarrierType, trigger: 'change' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: self.validatePassword(), trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次确认密码', trigger: 'blur' },
          { validator: self.validateEmailConfirmPwd(), trigger: 'blur' }
        ]
      },
      phoneOrEmailFlag: 'phoneRegister',
      disabledMobile: false,
      mobileTime: 0, // 获取手机验证码初始0
      disabledEmail: false,
      emailTime: 0, // 获取邮箱验证码初始0
      existEmail: ''
    };
  },
  methods: {
    Login () {
      let origin = window.location.origin;
      let url = origin + '/logisicsProvider.html#/';
      window.location.href = url;
    },
    gotoforgethtml () {
      let origin = window.location.origin;
      let url = origin + '/index.html#/findpassword';
      window.location.href = url;
    },
    phoneValid (callback) {
      let v = this;
      if (v.phoneFormParams.mobile !== '') {
        var obj = {
          mobile: v.phoneFormParams.mobile
        };
        v.axios.post(api.userIsExist, obj)
          .then(res => {
            if (res.data.code === 0) {
              if (callback && typeof callback === 'function') {
                callback();
              }
            } else if (res.data.code === 30003) {
              v.$Message.error('当前手机号码账号已存在');
            } else {
              v.$Message.error(res.data.message);
            }
          });
      }
    },
    phoneCodeValid () {
      let v = this;
      if (v.phoneFormParams.mobileCode !== '') {
        var obj = {
          mobileNo: v.phoneFormParams.mobile,
          mobileCode: v.phoneFormParams.mobileCode,
          msgType: '1'
        };
        v.axios.post(api.checkMobileCode, obj)
          .then(res => {
            if (res.data.code === 0) {

            } else if (res.data.code === 30004) {
              v.$Message.error('手机验证码输入错误，请重新输入');
            } else {
              v.$Message.error(res.data.message);
            }
          });
      }
    },
    emailValid (callback) {
      let v = this;
      if (v.emailFormParams.email !== '') {
        var obj = {
          email: v.emailFormParams.email
        };
        v.axios.post(api.userIsExist, obj)
          .then(res => {
            if (res.data.code === 0) {
              callback && callback();
            } else if (res.data.code === 30002) {
              v.$Message.error('当前邮箱账号已存在');
            } else {
              v.$Message.error(res.data.message);
            }
          });
      }
    },
    emailCodeValid () {
      let v = this;
      if (v.emailFormParams.emailCode !== '') {
        var obj = {
          email: v.emailFormParams.email,
          emailCode: v.emailFormParams.emailCode,
          msgType: '1'
        };
        v.axios.post(api.emailCodeValid, obj)
          .then(res => {
            if (res.data.code === 30007) {
              v.$Message.error('邮箱验证码输入错误，请重新输入');
            } else {
              v.$Message.error(res.data.message);
            }
          });
      }
    },
    // 手机号码校验
    validateMobile () {
      let validateMobile = function (rule, value, callback) {
        if (value.length !== 11 && value !== '') {
          callback(new Error('手机号码格式不正确'));
        } else {
          callback();
        }
      };
      return validateMobile;
    },
    // 密码格式校验
    validatePassword () {
      let validatePassword = function (rule, value, callback) {
        if (value.length < 6 || value.length > 16) {
          callback(new Error('密码长度应介于6~16位之间'));
        } else {
          callback();
        }
      };
      return validatePassword;
    },
    validateMobileConfirmPwd () {
      let v = this;
      let validateMobileConfirmPwd = function (rule, value, callback) {
        if (value !== v.phoneFormParams.password) {
          callback(new Error('确认密码和密码不一致'));
        } else {
          callback();
        }
      };
      return validateMobileConfirmPwd;
    },
    validateEmailConfirmPwd () {
      let v = this;
      let validateEmailConfirmPwd = function (rule, value, callback) {
        if (value !== v.emailFormParams.password) {
          callback(new Error('确认密码和密码不一致'));
        } else {
          callback();
        }
      };
      return validateEmailConfirmPwd;
    },
    // 启动手机验证码倒计时
    startMobileCountdown () {
      let v = this;
      v.mobileTime = 60;
      v.mobileTimer();
    },
    // 获取手机验证码定时器
    mobileTimer () {
      let v = this;
      if (v.mobileTime > 0) {
        v.mobileTime--;
        setTimeout(v.mobileTimer, 1000);
      }
    },
    // 发送手机验证码
    sendMobileCode () {
      let v = this;
      if (v.phoneFormParams.mobile === '') {
        v.$Message.error('请输入手机号码');
      } else if (v.phoneFormParams.mobile.length !== 11 && v.phoneFormParams.mobile !== '') {
        v.$Message.error('手机号码格式不正确');
      } else {
        v.phoneValid(() => {
          v.startMobileCountdown(); // 启用手机验证码倒计时
          var param = {
            mobileNo: v.phoneFormParams.mobile,
            msgType: '1'
          };
          v.axios.post(api.sendMobileCode, param)
            .then(res => {
              if (res.data.code === 0) {
                v.$Message.success('验证码已经发送到你的手机');
              } else {
                v.$Message.error(res.data.message);
              }
            });
        });
      }
    },
    // 启动手机验证码倒计时
    startEmailCountdown () {
      let v = this;
      v.emailTime = 60;
      v.emailTimer();
    },
    // 获取手机验证码定时器
    emailTimer () {
      let v = this;
      if (v.emailTime > 0) {
        v.emailTime--;
        setTimeout(v.emailTimer, 1000);
      }
    },
    // 发送邮箱验证码
    sendEmailCode () {
      let v = this;
      const reg = /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/;
      if (v.emailFormParams.email === '') {
        v.$Message.error('请输入邮箱地址');
      } else if (!reg.test(v.emailFormParams.email) && v.emailFormParams.email !== '') {
        v.$Message.error('邮箱格式不正确');
      } else {
        v.emailValid(() => {
          v.startEmailCountdown(); // 启用邮箱验证码倒计时
          var obj = {
            email: v.emailFormParams.email,
            msgType: '1'
          };
          v.axios.post(api.sendEmailCode, obj)
            .then(res => {
              if (res.data.code === 0) {
                v.$Message.success('验证码已经发送到你的邮箱');
              } else {
                v.$Message.error(res.data.message);
              }
            });
        });
      }
    },
    // 点击切换Tabs
    changeTabs (name) {
      let v = this;
      if (name === 'phoneRegister') {
        return (v.phoneOrEmailFlag = 'phoneRegister');
      } else if (name === 'emailRegister') {
        return (v.phoneOrEmailFlag = 'emailRegister');
      }
    },
    // 手机号码或者邮箱是否已经注册
    userIsExistFn () {
      let v = this;
      let isExistValid = true;
      if (v.phoneOrEmailFlag === 'phoneFindPassport') {
        var obj = {
          mobile: v.phoneFormParams.mobile
        };
        v.axios.post(api.userIsExist, obj)
          .then(res => {
            if (res.data.code === 0) {
            } else if (res.data.code === 30003) {
              v.$Message.error('当前手机号码注册失败，该账号已存在');
              isExistValid = false;
            } else {
              v.$Message.error(res.data.message);
              isExistValid = false;
            }
          });
        var param = {
          mobileNo: v.phoneFormParams.mobile,
          mobileCode: v.phoneFormParams.mobileCode,
          msgType: '1'
        };
        v.axios.post(api.checkMobileCode, param)
          .then(res => {
            if (res.data.code === 0) {
            } else if (res.data.code === 30004) {
              v.$Message.error('手机验证码输入错误，请重新输入');
              isExistValid = false;
            } else {
              v.$Message.error(res.data.message);
              isExistValid = false;
            }
          });
      } else if (v.phoneOrEmailFlag === 'emailFindPassport') {
        obj = {
          email: v.emailFormParams.email
        };
        v.axios.post(api.userIsExist, obj)
          .then(res => {
            if (res.data.code === 0) {
            } else if (res.data.code === 30002) {
              v.$Message.error('当前邮箱注册失败，该账号已存在');
              isExistValid = false;
            } else {
              v.$Message.error(res.data.message);
              isExistValid = false;
            }
          });
        param = {
          email: v.emailFormParams.email,
          emailCode: v.emailFormParams.emailCode,
          msgType: '1'
        };
        v.axios.post(api.checkEmailCode, param)
          .then(res => {
            if (res.data.code === 0) {
            } else if (res.data.code === 30007) {
              v.$Message.error('邮箱验证码输入错误，请重新输入');
              isExistValid = false;
            } else {
              v.$Message.error(res.data.message);
              isExistValid = false;
            }
          });
      }
      return isExistValid;
    },
    // 立即注册
    registerBtn () {
      let v = this;
      if (v.phoneOrEmailFlag === 'phoneRegister') {
        var mobileObj = {
          mobileNo: v.phoneFormParams.mobile, // 手机号码
          password: v.phoneFormParams.password, // 注册手机号码密码
          mobileCode: v.phoneFormParams.mobileCode,
          carrierType: v.phoneFormParams.carrierType,
          msgType: '1',
          registerType: 'mobile'
        };
        v.$refs['phoneFormParams'].validate((valid) => {
          if (valid) {
            if (v.singlePhone === false) {
              v.$Message.error('请勾选服务协议');
              return;
            }
            if (v.userIsExistFn()) {
              v.axios.post(api.saveUser, mobileObj)
                .then(res => {
                  if (res.data.code === 0) {
                    v.$Message.success('注册成功');
                    v.Login();
                  } else if (res.data.code === 30004) {
                    v.$Message.error('手机验证码输入错误，请重新输入');
                  } else {
                    v.$Message.error(res.data.message);
                  }
                });
            }
          } else {
            v.$Message.error('请填写必填项');
          }
        });
      } else if (v.phoneOrEmailFlag === 'emailRegister') {
        var emailObj = {
          email: v.emailFormParams.email, // 邮箱地址
          password: v.emailFormParams.password, // 注册邮箱密码
          emailCode: v.emailFormParams.emailCode,
          carrierType: v.emailFormParams.carrierType,
          msgType: '1',
          registerType: 'email'
        };
        v.$refs['emailFormParams'].validate((valid) => {
          if (valid) {
            if (v.singleEmail === false) {
              v.$Message.error('请勾选服务协议');
              return;
            }
            if (v.userIsExistFn()) {
              v.axios.post(api.saveUser, emailObj)
                .then(res => {
                  if (res.data.code === 0) {
                    v.$Message.success('注册成功');
                    v.Login();
                  } else if (res.data.code === 30007) {
                    v.$Message.error('邮箱验证码输入错误，请重新输入');
                  } else {
                    v.$Message.error(res.data.message);
                  }
                });
            }
          } else {
            v.$Message.error('请填写必填项');
          }
        });
      }
    }
  },
  computed: {
    mobileText: function () {
      return this.mobileTime > 0 ? this.mobileTime + 's再获取' : '获取验证码';
    },
    emailText: function () {
      return this.emailTime > 0 ? this.emailTime + 's再获取' : '获取验证码';
    }
  },
  watch: {
  }
};
</script>



// WEBPACK FOOTER //
// src/views/index/components/register.vue